import Button from "@material-ui/core/Button"
import { navigate } from "gatsby"
import React from "react"
import styled from "styled-components"

interface IProps {
  className?: string | undefined
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`

const Arrow = styled.span`
  margin-right: ${({ theme }) => theme.spacing(2)}px;
  padding-bottom: 2px;
`

const BackBtn: React.FC<IProps> = ({ className }) => {
  return (
    <Wrapper className={className}>
      <Button onClick={() => navigate(-1)} size="large">
        <Arrow>←</Arrow>Terug
      </Button>
    </Wrapper>
  )
}

export default BackBtn
